export const ITEMIZATION_WIDGET_ACTION = {
  FETCH_DATA_SUCCESS: "FETCH_DATA_SUCCESS",
  FETCH_DATA_FAILED: "FETCH_DATA_FAILED",
  RESET_DATA: "RESET_DATA"
};

export const resetItemizationWidgetData = () => ({
  type: ITEMIZATION_WIDGET_ACTION.RESET_DATA
});
